import React from 'react';
import styles from 'feature/street-parking/index.module.sass';
import { useHistory } from 'react-router-dom';
import PageLayout from 'layout/page';
import StreetParkingLayout from 'layout/street-parking';
import CardItem from 'components/card-item';
import LoadingDialog from 'components/loading-dialog';
import { useAppContext } from 'use-app';
import get from 'lodash/get';
import { PATH } from 'config';

const StreetParkingCities = () => {
  const history = useHistory();
  const { state: appState } = useAppContext();
  const cities = get(appState, 'bootstraps.searchStreetParkingBillsCities', []);

  const CityCardItem = ({ city, isSelected, onClick }) => {
    const bgColor = isSelected ? 'bgBlue' : '';
    return (
      <div className={styles.card}>
        <CardItem bgColor={bgColor} content={city.name} onClick={onClick} />
      </div>
    );
  };

  return (
    <>
      <LoadingDialog isShow={appState.loading} />
      <PageLayout>
        <StreetParkingLayout cities={appState.bootstraps?.autoPayStreetParkingBillsCities} className={styles.cities}>
          <div className={styles.title}>請選擇一個縣市</div>
          {
            <div className={styles.cities}>
              {cities.map(city => {
                return (
                  <CityCardItem
                    key={city.id}
                    city={city}
                    onClick={() => {
                      history.replace({
                        pathname: PATH.STREET_PARKING_PLATES,
                        search: `city=${city.id}`,
                      });
                    }}
                  />
                );
              })}
            </div>
          }
        </StreetParkingLayout>
      </PageLayout>
    </>
  );
};

export default StreetParkingCities;
